function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_ficha_tecnica_a,.icon_menu_ficha_tecnica_g{fill:#fff;}\n      .icon_menu_ficha_tecnica_a{stroke:#707070;}\n      .icon_menu_ficha_tecnica_b{clip-path:url(#icon_menu_ficha_tecnica_a);}\n      .icon_menu_ficha_tecnica_c{fill:#2196f3;}\n      .icon_menu_ficha_tecnica_d{fill:#1976d2;}\n      .icon_menu_ficha_tecnica_e{fill:#1d83d4;}\n      .icon_menu_ficha_tecnica_f{fill:#1667b7;}\n      .icon_menu_ficha_tecnica_h{fill:#dedede;}\n      .icon_menu_ficha_tecnica_i{fill:#ffc107;}\n      .icon_menu_ficha_tecnica_j{fill:#dea806;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_ficha_tecnica_a"
}, React.createElement("rect", {
  className: "icon_menu_ficha_tecnica_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1126)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_ficha_tecnica_b",
  transform: "translate(-1800 -1126)"
}, React.createElement("g", {
  transform: "translate(1800 1126)"
}, React.createElement("path", {
  className: "icon_menu_ficha_tecnica_c",
  d: "M12.073,19h-9.9A2.179,2.179,0,0,1,0,16.823V4.552A2.179,2.179,0,0,1,2.177,2.375h9.9A2.179,2.179,0,0,1,14.25,4.552V16.823A2.179,2.179,0,0,1,12.073,19Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_d",
  d: "M9.7,4.75H4.552A1.387,1.387,0,0,1,3.167,3.365V2.177a.594.594,0,0,1,.594-.594H5.029a2.178,2.178,0,0,1,4.19,0h1.27a.594.594,0,0,1,.594.594V3.365A1.387,1.387,0,0,1,9.7,4.75Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_e",
  d: "M3.167,2.375h-.99A2.179,2.179,0,0,0,0,4.552V16.823A2.179,2.179,0,0,0,2.177,19H7.125V4.75H4.552A1.387,1.387,0,0,1,3.167,3.365Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_f",
  d: "M7.125,0A2.181,2.181,0,0,0,5.03,1.583H3.76a.594.594,0,0,0-.594.594V3.365A1.387,1.387,0,0,0,4.552,4.75H7.125Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_g",
  d: "M11.281,8.313H2.969a.594.594,0,0,1,0-1.187h8.313a.594.594,0,0,1,0,1.188Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_g",
  d: "M11.281,10.688H2.969a.594.594,0,0,1,0-1.187h8.313a.594.594,0,0,1,0,1.188Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_g",
  d: "M11.281,13.063H2.969a.594.594,0,0,1,0-1.187h8.313a.594.594,0,0,1,0,1.188Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_g",
  d: "M11.281,15.438H2.969a.594.594,0,0,1,0-1.187h8.313a.594.594,0,0,1,0,1.188Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_h",
  d: "M7.125,7.125H2.969a.594.594,0,0,0,0,1.188H7.125Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_h",
  d: "M7.125,9.5H2.969a.594.594,0,0,0,0,1.188H7.125Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_h",
  d: "M7.125,11.875H2.969a.594.594,0,0,0,0,1.188H7.125Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_h",
  d: "M7.125,14.25H2.969a.594.594,0,0,0,0,1.188H7.125Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_i",
  d: "M17.417,16.625a.4.4,0,0,1-.354-.218l-1.02-2.041a1.988,1.988,0,0,1-.209-.885V6.333a1.583,1.583,0,1,1,3.167,0v7.147a1.988,1.988,0,0,1-.209.885h0l-1.02,2.041a.4.4,0,0,1-.354.218Zm1.02-2.437h.008Z"
}), React.createElement("path", {
  className: "icon_menu_ficha_tecnica_j",
  d: "M17.417,4.75a1.585,1.585,0,0,0-1.583,1.583v7.147a1.988,1.988,0,0,0,.209.885l1.02,2.041a.4.4,0,0,0,.354.218Z"
})));

var SvgFichaTecnica = function SvgFichaTecnica(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFichaTecnica, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ficha-tecnica.61ed2da1.svg";
export { ForwardRef as ReactComponent };